import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { workflowAPI } from '../../lib/api';
import { errMsg } from '../../lib/workflow';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const QUICK = ['Add a hand / model shot ✋', 'Cleaner, brighter background ☀️', 'Show the side profile 💍', 'Add a video 🎬', 'Fix the metal tone 🎨'];

export const RequestChangesDialog = ({ item, onClose, onDone }) => {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { setText(''); }, [item]);

  const submit = async () => {
    if (!text.trim()) { toast.error('Write what needs changing ✍️'); return; }
    setBusy(true);
    try {
      const r = await workflowAPI.requestChanges(item.id, text);
      toast.success('Sent back to Nivedit 🔁');
      onDone?.(r.data);
      onClose();
    } catch (e) {
      toast.error(errMsg(e, 'Could not send changes'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!item} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-lg bg-white rounded-3xl border-[#E8E1D5]" data-testid="request-changes-dialog">
        <DialogHeader>
          <DialogTitle className="font-jakarta text-xl">🔁 Request changes</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#6E635B]">Tell Nivedit what to fix on <b>{item?.name}</b>. It goes straight back to the top of his queue.</p>
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={4}
          autoFocus
          placeholder="e.g. Hero shot is too dark, please add a hand shot in rose gold…"
          className="rounded-2xl border-[#E8E1D5] bg-[#FDFBF7] resize-none"
          data-testid="request-changes-input"
        />
        <div className="flex flex-wrap gap-1.5">
          {QUICK.map((q) => (
            <button key={q} type="button" onClick={() => setText((v) => (v ? `${v}\n${q}` : q))} className="text-[11px] rounded-full bg-[#FFF1F2] text-[#9F1239] px-2.5 py-1 hover:bg-[#FFE4E6]">
              + {q}
            </button>
          ))}
        </div>
        <div className="flex gap-2 pt-2">
          <Button variant="outline" className="flex-1 rounded-xl" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={busy} className="flex-1 rounded-xl bg-[#E11D48] hover:bg-[#BE123C] text-white" data-testid="request-changes-submit-btn">
            {busy ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : null} Send to Nivedit 🔁
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
